var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"py-6 hidden"},[_c('div',{staticClass:"max-w-6xl mx-auto px-2"},[_c('p',{staticClass:"text-xs"},[_vm._v("© 2020 grund_schule der Künste")])])])
}]

export { render, staticRenderFns }